import { DepthSocketUpdateI } from '@app/_shared/providers';

interface DepthList {
    askOrderCount: number;
    askPrice: number;
    askQty: number;
    avgAskPrice: number;
    avgBidPrice: number;
    bidPrice: number;
    bidQty: number;
    bidOrderCount: number;
}

export class Depth {
    depth: DepthList[] = new Array(5);

    constructor() {
        this.generateEmptyDepth();
    }

    generateEmptyDepth() {
        for (let index = 0; index < 5; index++) {
            this.depth[index] = {
                askOrderCount: null,
                askPrice: null,
                askQty: null,
                avgAskPrice: null,
                avgBidPrice: null,
                bidPrice: null,
                bidQty: null,
                bidOrderCount: null
            }
        }
    }

    updateDepth(update: DepthSocketUpdateI[]) {
        this.depth.forEach((depth, idx) => {
            depth.askOrderCount = update[idx]?.NoOfAsks || 0;
            depth.askPrice = update[idx]?.AskPrice || 0;
            depth.askQty = update[idx]?.AskQty || 0;
            depth.avgAskPrice = update[idx]?.AvgAskPrice || 0;
            depth.avgBidPrice = update[idx]?.AvgBidPrice || 0;
            depth.bidPrice = update[idx]?.BidPrice || 0;
            depth.bidQty = update[idx]?.BidQty || 0;
            depth.bidOrderCount = update[idx]?.NoOfBids || 0;
        })
    }
}